import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StoreLocatorLayoutSwitcher } from "./components/StoreLocatorLayoutSwitcher/StoreLocatorLayoutSwitcher";
import { StoreLocatorProviderWrapper } from "./components/StoreLocatorProviderWrapper";
import { StoreLocatorV1 } from "./components/StoreLocatorV1";
import { StoreLocatorV2 } from "./components/StoreLocatorV2";
import { StoreLocatorContext } from "./context";
import { useStoreLocator } from "./hooks";
export const StoreLocator = (props) => {
    const storeLocatorData = useStoreLocator({ ...props });
    return (_jsx(StoreLocatorProviderWrapper, { componentLevelLanguage: props.componentLevelLanguage, children: _jsxs(StoreLocatorContext.Provider, { value: storeLocatorData, children: [_jsx(StoreLocatorLayoutSwitcher, { layout: "v1", children: _jsx(StoreLocatorV1, {}) }), _jsx(StoreLocatorLayoutSwitcher, { layout: "v2", children: _jsx(StoreLocatorV2, {}) })] }) }));
};
//# sourceMappingURL=StoreLocator.js.map